import styled from 'styled-components';

export const BodyContainer = styled.div`
  display: flex;
  height: 100svh;
  flex-direction: column;
  align-self: stretch;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 0.5rem;
  background: white;
  z-index: 3;
`;
